import { translate } from '@jsverse/transloco';
export enum CvssV4Option {
    LOW = 'Low',
    MEDIUM = 'Medium',
    HIGH = 'High',
}

export class CvssV4OptionHelper {
    static getCvssV4OptionLocale(cvssV4Option: CvssV4Option): string {
        switch (cvssV4Option) {
            case CvssV4Option.LOW:
                return translate('CORE.CVSS_V4.OPTION.LOW');
            case CvssV4Option.MEDIUM:
                return translate('CORE.CVSS_V4.OPTION.MEDIUM');
            case CvssV4Option.HIGH:
                return translate('CORE.CVSS_V4.OPTION.HIGH');
            default:
                return '';
        }
    }
}
